/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import * as Types from '../../../types/schema.generated';

import gql from 'graphql-tag';
import * as VueApolloComposable from '@vue/apollo-composable';
import * as VueCompositionApi from 'vue';
export type ReactiveFunction<TParam> = () => TParam;
export type PamphletViewDocumentFragment = { __typename: 'SolicitorCloudPamphletDocument', id: string, title: string, createdAt: DateTimeString, updatedAt: DateTimeString, currentDocumentVersion: { id: string, publishedAt: DateTimeString } | null };

export type PamphletViewCorporationFragment = { id: string, name: string, documents: Array<
    | { __typename: 'SolicitorCloudPamphletDocument', id: string, title: string, createdAt: DateTimeString, updatedAt: DateTimeString, currentDocumentVersion: { id: string, publishedAt: DateTimeString } | null }
    | Record<PropertyKey, never>
  > };

export type GetPamphletViewDocumentFileUrlQueryVariables = Exact<{
  ids: Array<string | number> | string | number;
}>;


export type GetPamphletViewDocumentFileUrlQuery = { solicitorCloudPamphletDocumentVersionByIds: Array<{ fileUrl: string }> };

export const PamphletViewDocumentFragmentDoc = gql`
    fragment PamphletViewDocument on SolicitorCloudPamphletDocument {
  __typename
  id
  title
  createdAt
  updatedAt
  currentDocumentVersion {
    id
    publishedAt
  }
}
    `;
export const PamphletViewCorporationFragmentDoc = gql`
    fragment PamphletViewCorporation on SolicitorCloudCorporation {
  id
  name
  documents {
    ... on SolicitorCloudPamphletDocument {
      ...PamphletViewDocument
    }
  }
}
    ${PamphletViewDocumentFragmentDoc}`;
export const GetPamphletViewDocumentFileUrlDocument = gql`
    query getPamphletViewDocumentFileUrl($ids: [ID!]!) {
  solicitorCloudPamphletDocumentVersionByIds(ids: $ids) {
    fileUrl
  }
}
    `;

/**
 * __useGetPamphletViewDocumentFileUrlQuery__
 *
 * To run a query within a Vue component, call `useGetPamphletViewDocumentFileUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPamphletViewDocumentFileUrlQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetPamphletViewDocumentFileUrlQuery({
 *   ids: // value for 'ids'
 * });
 */
export function useGetPamphletViewDocumentFileUrlQuery(variables: GetPamphletViewDocumentFileUrlQueryVariables | VueCompositionApi.Ref<GetPamphletViewDocumentFileUrlQueryVariables> | ReactiveFunction<GetPamphletViewDocumentFileUrlQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetPamphletViewDocumentFileUrlQuery, GetPamphletViewDocumentFileUrlQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetPamphletViewDocumentFileUrlQuery, GetPamphletViewDocumentFileUrlQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetPamphletViewDocumentFileUrlQuery, GetPamphletViewDocumentFileUrlQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetPamphletViewDocumentFileUrlQuery, GetPamphletViewDocumentFileUrlQueryVariables>(GetPamphletViewDocumentFileUrlDocument, variables, options);
}
export function useGetPamphletViewDocumentFileUrlLazyQuery(variables?: GetPamphletViewDocumentFileUrlQueryVariables | VueCompositionApi.Ref<GetPamphletViewDocumentFileUrlQueryVariables> | ReactiveFunction<GetPamphletViewDocumentFileUrlQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetPamphletViewDocumentFileUrlQuery, GetPamphletViewDocumentFileUrlQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetPamphletViewDocumentFileUrlQuery, GetPamphletViewDocumentFileUrlQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetPamphletViewDocumentFileUrlQuery, GetPamphletViewDocumentFileUrlQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetPamphletViewDocumentFileUrlQuery, GetPamphletViewDocumentFileUrlQueryVariables>(GetPamphletViewDocumentFileUrlDocument, variables, options);
}
export type GetPamphletViewDocumentFileUrlQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetPamphletViewDocumentFileUrlQuery, GetPamphletViewDocumentFileUrlQueryVariables>;